import caseStrategyController from "./case-strategy-controller";
import dataInfoExcelController from "./data-info-excel-controller";
import accImportExcelDataController from "./acc-import-excel-data-controller";
import scoreStrategyController from "./score-strategy-controller";
import dataImportExcelInfoController from "./data-import-excel-info-controller";
import importExcelConfigController from "./import-excel-config-controller";
import labelingStrategyController from "./labeling-strategy-controller";
import strategyConfigController from "./strategy-config-controller";
import caseInfoConfirmController from "./case-info-confirm.controller";
export var dataimpService = {
    caseStrategyController: caseStrategyController,
    dataInfoExcelController: dataInfoExcelController,
    accImportExcelDataController: accImportExcelDataController,
    scoreStrategyController: scoreStrategyController,
    dataImportExcelInfoController: dataImportExcelInfoController,
    importExcelConfigController: importExcelConfigController,
    labelingStrategyController: labelingStrategyController,
    strategyConfigController: strategyConfigController,
    caseInfoConfirmController: caseInfoConfirmController
};
